import React, { useEffect, useState } from 'react';
import { Layout, Breadcrumb } from 'antd';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguages } from 'src/actions/LanguagesAction';
import ContentReviewDetailBody from './ContentReviewDetailBody';
import InnerHeader from '../../component/InnerHeader';
import {
  fetchContentReviews,
  fetchContentReviewById,
  setContentReviewDraft,
  updateContentReviewAction
} from '../../actions/contentReviewAction';
import Loader from '../../component/Loader/Loader';
import { deleteContentReview } from '../../services/napi';

import ArrowNextIcon from '../../asset/arrow-next.svg';

const ContentReviewDetail = () => {
  const dispatch = useDispatch();

  const { contentReviewId } = useParams();
  const [isSaveEnabled, setSaveEnabled] = useState(true);

  const contentData = useSelector(
    ({ contentReview }) => contentReview.contentReviewStore[contentReviewId]
  );

  useEffect(() => {
    async function load() {
      dispatch(setContentReviewDraft({}));
      dispatch(fetchContentReviewById(contentReviewId, true));
      dispatch(fetchLanguages());
    }

    load();
  }, [contentReviewId, dispatch]);

  const contentReviewDraft = useSelector(({ contentReview }) => contentReview.contentReviewDraft);
  const contentReview = useSelector(({ contentReview }) => contentReview.contentReview);
  const projectId = useSelector(({ project }) => project.currentProject._id);

  const setDraft = (content) => {
    dispatch(setContentReviewDraft(content));
  };

  const [reRender, setRerender] = useState(false);

  const handleCallBack = (data) => {
    const newContent = contentReviewDraft;
    if (data) {
      newContent.name = data;
      setDraft(newContent);
      setRerender(!reRender);
    }
  };

  if (!contentData || !Object.keys(contentReviewDraft).length) {
    return <Loader />;
  }

  const onUpdate = async (reviewStatus) => {
    setSaveEnabled(false);
    delete contentReviewDraft.data.undefined;
    dispatch(updateContentReviewAction(contentReviewDraft._id, reviewStatus));
    setSaveEnabled(true);
    onBack();
  };

  async function removeContent() {
    await deleteContentReview(contentReviewId, projectId);
    dispatch(fetchContentReviews());
    window.history.back();
  }

  const actions = [
    { onClick: removeContent, title: 'Delete' },
    {
      disabled: !isSaveEnabled,
      onClick: () => onUpdate('accepted'),
      title: 'Publish',
      type: 'primary'
    },
    {
      disabled: !isSaveEnabled,
      onClick: () => onUpdate('rejected'),
      title: 'Reject',
      type: 'primary'
    }
  ];

  const routes = [
    {
      breadcrumbName: 'home',
      path: '/content-review'
    },
    {
      breadcrumbName: contentReviewDraft.name,
      path: `/${contentReviewId}`
    }
  ];

  function itemRender(route, params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    );
  }

  const onBack = () => {
    window.history.back();
  };

  return (
    <Layout>
      <Breadcrumb
        itemRender={itemRender}
        routes={routes}
        separator={<img alt="next icon" src={ArrowNextIcon} />}
        style={{
          background: 'white',
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '40px 0px 34px 35px'
        }}
      />

      <InnerHeader
        actions={actions}
        copyId={contentData?.customType?.api_id}
        onBack={onBack}
        parentCallBack={handleCallBack}
        subtitle=""
        title={contentReviewDraft.name}
      />

      <div
        style={{
          alignItems: 'flex-start',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start'
        }}
      >
        <ContentReviewDetailBody contentDraft={contentReview} setContentDraft={() => {}} />

        <ContentReviewDetailBody
          contentDraft={contentReviewDraft}
          isEditable
          setContentDraft={setDraft}
        />
      </div>
    </Layout>
  );
};

export default ContentReviewDetail;
